import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { shipstationConnect } from '../../services/shipstation-connect/';

import * as Actions from './one-time-scale.actions';

export const oneTimeReadScaleRequestEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.ONE_TIME_READ_SCALE_REQUEST),
    mergeMap(({ scale, requestId }) => {
      shipstationConnect.readFromScale(scale, requestId);
      return EMPTY;
    }),
  );
};
